<template>
	<div>
		<tab name="2">{{ id }} {{ formData.activityName }} <b v-if="formData && formData.haveEditAudit"
				class="color-danger">存在还未处理的演出修改审核，请处理后再编辑演出信息</b></tab>
		<el-form :model="formData" :rules="rules" ref="formData" label-position="top" v-loading="dataLoading"
			:disabled="formData && formData.haveEditAudit" size="medium" class="forms">
			<el-card header="基本设置">
				<el-descriptions :column="1" border size="small" class="basic-settings" :labelStyle="{ width: '200px' }">
					<el-descriptions-item label="售票模式">
						<el-form-item prop="sellIdentity">
							<el-radio-group v-model="formData.sellIdentity">
								<el-radio :label="1">秀动独家</el-radio>
								<el-radio :label="2">多平台售票</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启抢票攻略">
						<small><span class="color-warning" style="font-size: 12px;">抢票攻略和选座、预售购票不能同时设置</span></small>
						<el-form-item prop="openStrategy">
							<el-radio-group v-model="formData.openStrategy"
								:disabled="dataDetail && dataDetail.haveEditAudit">
								<el-radio :label="0">不开启</el-radio>
								<el-radio :label="1">开启</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启开票倒计时">
						<el-form-item prop="isShowCountdown">
							<el-radio-group v-model="formData.isShowCountdown" @change="changeCountdown">
								<el-radio :label="0">不开启</el-radio>
								<el-radio :label="1">开启后依次展示倒计时</el-radio>
								<el-radio :label="2">开启后仅展示最早开票倒计时</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启收藏数展示">
						<el-form-item prop="wishStatus">
							<el-radio-group v-model="formData.wishStatus">
								<el-radio :label="0">不开启</el-radio>
								<el-radio :label="1">开启</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item prop="wishNum" v-if="formData.wishStatus == 1">
							<span>
								自定义展示数量：<small><span class="color-warning"
										style="font-size: 12px;margin-right:20px">(0为按真实数据展示)</span></small>
							</span>
							<el-input-number v-model="formData.wishNum" :precision="0" :min="0" :max="10000000"
								size="medium" placeholder="请填写自定义展示数量"></el-input-number>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启票品折叠">
						<el-form-item prop="isFold">
							<el-radio-group v-model="formData.isFold">
								<el-radio :label="0">不开启</el-radio>
								<el-radio :label="1">开启</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否发送下单成功短信">
						<el-form-item prop="sendOrderMsg">
							<el-radio-group v-model="formData.sendOrderMsg">
								<el-radio :label="0">否</el-radio>
								<el-radio :label="1">是</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="演出账号限购">
						<el-form-item prop="accountLimitNum">
							<el-input-number v-model="formData.accountLimitNum" :precision="0" :min="0" :max="99999999"
								size="medium" placeholder="请填写限购数量"></el-input-number>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="演出证件号限购">
						<el-form-item prop="certificateLimitBuyNum">
							<el-input-number v-model="formData.certificateLimitBuyNum" :precision="0" :min="0"
								:max="99999999" size="medium" placeholder="请填写限购数量"></el-input-number>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="绑定酒店">
						<el-form-item prop="isBindHotel">
							<el-select v-model="formData.isBindHotel" style="width:300px">
								<el-option :value="0" label="不绑定酒店"></el-option>
								<el-option :value="2" label="绑定特定酒店"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="formData.isBindHotel == 2" prop="hotelId" style="width:300px">
							<el-select v-model="formData.hotelId" filterable remote multiple placeholder="请输入酒店ID"
								:remote-method="searchHotel" :loading="hotelLoading">
								<el-option v-for="item in hotelList" :key="item.id" :label="`${item.id} - ${item.name}`"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启前端用户申请发票">
						<el-form-item prop="invoiceStatus">
							<el-radio-group v-model="formData.invoiceStatus">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<template v-if="formData.invoiceStatus == 1">
							<el-form-item prop="invoiceDays">场次结束 <el-input-number v-model="formData.invoiceDays"
									:precision="0" :min="10" :max="180" size="medium"
									placeholder="请输入候补队列长度"></el-input-number> 天内可申请</el-form-item>
						</template>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启自动打开候补">
						<el-form-item prop="autoOpenAlternate">
							<el-radio-group v-model="formData.autoOpenAlternate">
								<el-radio :label="1">开启</el-radio>
								<el-radio :label="0">不开启</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启自动打开托售">
						<el-form-item prop="autoOpenConsign">
							<el-radio-group v-model="formData.autoOpenConsign">
								<el-radio :label="1">开启</el-radio>
								<el-radio :label="0">不开启</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启自动打开定时购">
						<el-form-item prop="autoOpenPreBuy">
							<el-radio-group v-model="formData.autoOpenPreBuy">
								<el-radio :label="1">开启</el-radio>
								<el-radio :label="0">不开启</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否开启三方录入座位提醒">
						<el-form-item prop="seatEnter">
							<el-radio-group v-model="formData.seatEnter">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
					<el-descriptions-item label="是否参与秀动校园代理活动">
						<el-form-item prop="campusAgentStatus">
							<el-radio-group v-model="formData.campusAgentStatus">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-descriptions-item>
				</el-descriptions>
			</el-card>
			<el-card class="MT20" header="售票终端">
				<el-row :gutter="20">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<div slot="title">APP <small><span class="color-danger">乐迷APP当前必须允许售票</span></small></div>
							<el-descriptions-item label="售票设置">
								<el-form-item prop="appSellStatus">
									<el-radio-group v-model="formData.appSellStatus" disabled>
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="appHideType">
									<el-radio-group v-model="formData.appHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions title="WAPCN" :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<el-descriptions-item label="售票设置">
								<el-form-item prop="wapSellStatus">
									<el-radio-group v-model="formData.wapSellStatus">
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="wapHideType">
									<el-radio-group v-model="formData.wapHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="MT20">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions title="支付宝小程序" :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<el-descriptions-item label="售票设置">
								<el-form-item prop="aliSellStatus">
									<el-radio-group v-model="formData.aliSellStatus">
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="aliHideType">
									<el-radio-group v-model="formData.aliHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions title="微信小程序" :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<el-descriptions-item label="售票设置">
								<el-form-item prop="wxSellStatus">
									<el-radio-group v-model="formData.wxSellStatus">
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
										<el-radio :label="3">正价票开演当天可售</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="wxHideType">
									<el-radio-group v-model="formData.wxHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>

				</el-row>
				<el-row :gutter="20" class="MT20">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions title="抖音小程序" :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<el-descriptions-item label="售票设置">
								<el-form-item prop="byteSellStatus">
									<el-radio-group v-model="formData.byteSellStatus">
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="byteHideType">
									<el-radio-group v-model="formData.byteHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions title="小红书小程序" :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<el-descriptions-item label="售票设置">
								<el-form-item prop="redSellStatus">
									<el-radio-group v-model="formData.redSellStatus">
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="redHideType">
									<el-radio-group v-model="formData.redHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="MT20">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions title="美团小程序" :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<el-descriptions-item label="售票设置">
								<el-form-item prop="meiTuanSellStatus">
									<el-radio-group v-model="formData.meiTuanSellStatus">
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="meiTuanHideType">
									<el-radio-group v-model="formData.meiTuanHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<div slot="title">WEB <small><span class="color-danger">WEB不支持售票</span></small></div>
							<el-descriptions-item label="售票设置">
								<el-form-item prop="webSellStatus">
									<el-radio-group v-model="formData.webSellStatus" disabled>
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="webHideType">
									<el-radio-group v-model="formData.webHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="MT20">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-descriptions title="太校园小程序" :column="1" border size="small" :labelStyle="{width:'90px'}" class="terminal-desc">
							<el-descriptions-item label="售票设置">
								<el-form-item prop="taiYouthSellStatus">
									<el-radio-group v-model="formData.taiYouthSellStatus">
										<el-radio :label="1">售票</el-radio>
										<el-radio :label="2">不售票</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
							<el-descriptions-item label="展示设置">
								<el-form-item prop="taiYouthHideType">
									<el-radio-group v-model="formData.taiYouthHideType">
										<el-radio :label="0">正常展示</el-radio>
										<el-radio :label="1">列表隐藏</el-radio>
										<el-radio :label="2">列表和详情页隐藏</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
				</el-row>

			</el-card>
			<el-card class="MT20" header="推送至抖音生活服务">
				<el-row :gutter="20">
					<el-col :xs="24" :xl="16">
						<el-form-item>
							<div>
								<small class="color-warning lineH24">1、抖音演出类目, 要求推送演出, 必须先到 <a
										href="https://life.douyin.com/" target="_blank" class="color-blue">抖音来客平台</a>
									手动添加资质 <br>2、两种资质不能为空, 且必须在来客平台已审核通过,
									否则演出推送会审核失败或下架<br>3、营业性演出准予许可决定资质: 演出批文<br>4、演出主办方授权书资质: 主办方对秀动售票授权书</small>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item label="演出标题：" prop="douyinActivityName">
							<el-input v-model="formData.douyinActivityName" placeholder="请输入演出标题" size="small"
								style="width: 80%;" />
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item label="活动类型：" prop="douyinActivityType">
							<el-cascader v-model="formData.douyinActivityType" :options="showTypeTagList"
								:props="{ value: 'id', label: 'name', children: 'tags', emitPath: false }" placeholder="请选择活动类型"
								size="medium" style="width:80%"></el-cascader>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item label="">
							<span slot="label">营业性演出准予许可决定资质ID <el-button icon="el-icon-plus" size="mini" type="primary"
									@click="addId()">添加ID</el-button></span>
							<ul>
								<!-- <li v-for="num in ParamsNum" :key="num">
									<el-input v-model="temp.params[num].key" placeholder="请输入主办批文资质 id" size="small" :maxlength="22"
										class="ipt" style="width: 80%;" @change="changeIpt()" /> <i
										class="el-icon-remove-outline" @click="del(num)"></i>
								</li> -->
								<li v-for="(item, index) in douyinIdData[0]" :key="index">
									<el-input v-model="douyinIdData[0][index]" placeholder="请输入营业性演出准予许可决定资质 id"
										size="small" :maxlength="22" class="ipt" style="width: 80%;" /> <i
										class="el-icon-remove-outline" @click="del(index)"></i>
								</li>
							</ul>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item label="">
							<span slot="label">演出主办方授权书资质ID <el-button icon="el-icon-plus" size="mini" type="primary"
									@click="addId2()">添加ID</el-button></span>
							<ul>
								<!-- <li v-for="num in ParamsNum2" :key="num">
									<el-input v-model="temp2.params[num].key" placeholder="请输入演出主办方授权书 id" size="small" :maxlength="22"
										class="ipt" style="width: 80%;" @change="changeIpt()" /> <i
										class="el-icon-remove-outline" @click="del2(num)"></i>
								</li> -->
								<li v-for="(item, index) in douyinIdData[1]" :key="index">
									<el-input v-model="douyinIdData[1][index]" placeholder="请输入演出主办方授权书资质 id"
										size="small" :maxlength="22" class="ipt" style="width: 80%;" /> <i
										class="el-icon-remove-outline" @click="del2(index)"></i>
								</li>

							</ul>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xs="24" :xl="16">
						<el-form-item prop="isPushAppMsg">
							<div class="page-group-title">
								<span>当前推送状态：</span>
								<span>
									<span v-if="showdouyinActivityStatus == 0">{{
										douyinActivityStatus.get(showdouyinActivityStatus)
										}}</span>
									<span v-if="showdouyinActivityStatus == 1 || showdouyinActivityStatus == 2">{{
										douyinActivityStatus.get(showdouyinActivityStatus) }}</span>
									<span v-if="showdouyinActivityStatus == 3 || showdouyinActivityStatus == 4">{{
										douyinActivityStatus.get(showdouyinActivityStatus) }}</span>

									<!-- <el-radio-group v-model="status" class="ML50" @change="changeDyType()">
									    <el-radio :label="1" v-if="showdouyinActivityStatus == 0 || showdouyinActivityStatus == 3" :disabled="ParamsNum == 0 || ParamsNum2 == 0 ">推送抖音(资质 id不能为空)</el-radio>
									    <el-radio :label="1" v-if="showdouyinActivityStatus == 2 || showdouyinActivityStatus == 4" :disabled="ParamsNum == 0 || ParamsNum2 == 0 ">修改并重新推送(抖音会重新审核且资质 id不能为空)</el-radio>
										<el-radio :label="3" v-if="showdouyinActivityStatus == 4">上架(不修改内容,不需审核)</el-radio>
										<el-radio :label="2" v-if="showdouyinActivityStatus == 2">下架</el-radio>
									</el-radio-group> -->
									<span v-if="showdouyinActivityStatus == 0 || showdouyinActivityStatus == 3"
										class="ML50 hand" @click="changeDyType(1)">推送抖音</span>
									<span v-if="showdouyinActivityStatus == 2 || showdouyinActivityStatus == 4"
										class="ML50 hand" @click="changeDyType(1)">修改并重新推送(抖音会重新审核)</span>
									<span v-if="showdouyinActivityStatus == 4" class="ML50 hand"
										@click="changeDyType(3)">上架(不修改内容,不需审核)</span>
									<span v-if="showdouyinActivityStatus == 2" @click="changeDyType(2)"
										class="ML50 hand">下架</span>
								</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row><!-- v-if="douyinBindShow" -->
					<el-card
						shadow="never"><!-- douyinSiteStatus 场地 是否绑定抖音POI 0:未绑定 1:绑定中 2:绑定成功 3:绑定失败 douyinActivityStatus -->
						<el-row>
							<el-col :xs="24" :sm="12">
								<el-row>
									<el-col><span class="color-info">Step1: </span><el-link
											:href="`/user/site/edit/openservice/${formData.siteId}`"
											class="link-blue">绑定场地和抖音POI</el-link></el-col>
									<el-col class="MT10"><span class="color-info">状态: </span>
										<span>{{ douyinSiteStatus.get(formData.douyinSiteStatus) }}</span>
									</el-col>
									<el-col class="MT10"
										v-if="formData.douyinSitePoiId && formData.douyinSiteStatus == 2">
										<span class="color-info">POI ID: </span><el-link
											:href="`https://aweme.snssdk.com/falcon/poi_mwa/poi_detail?poi_id=${formData.douyinSitePoiId}`"
											target="_blank" type="primary">{{ formData.douyinSitePoiId }}</el-link>
									</el-col>
									<el-col class="MT10" v-if="formData.douyinSiteBindTime"><span
											class="color-info">绑定时间:
										</span>{{ formData.douyinSiteBindTime }}</el-col>
									<el-col class="MT10"
										v-if="formData.douyinSiteBindRemark && formData.douyinSiteStatus == 3"><span
											class="color-info">原因: </span>{{ formData.douyinSiteBindRemark }}</el-col>
								</el-row>
							</el-col>
							<el-col :xs="24" :sm="12" v-if="showdouyinActivityStatus != 0">
								<el-row>
									<el-col><span class="color-info">Step2: </span>推送演出信息及抖音生活服务</el-col>
									<el-col class="MT10"><span class="color-info">状态: </span>
										<el-link v-if="formData.douyinActivityPoiId && showdouyinActivityStatus == 2"
											:href="`https://aweme.snssdk.com/falcon/poi_mwa/poi_detail?poi_id=${formData.douyinActivityPoiId}`"
											target="_blank" type="primary">
											{{ douyinActivityStatus.get(showdouyinActivityStatus) }}</el-link>
										<span v-else>{{ douyinActivityStatus.get(showdouyinActivityStatus) }}</span>
									</el-col>
									<el-col class="MT10" v-if="formData.douyinActivityPoiId">
										<span class="color-info">Product ID: </span>{{ formData.douyinActivityPoiId }}
									</el-col>
									<el-col class="MT10"
										v-if="formData.douyinActivityBindTime && showdouyinActivityStatus == 2"><span
											class="color-info">成功时间: </span>{{ formData.douyinActivityBindTime
										}}</el-col>
									<el-col class="MT10"
										v-if="formData.douyinActivityBindTime && showdouyinActivityStatus == 4"><span
											class="color-info">下架时间: </span>{{ formData.douyinActivityBindTime
										}}</el-col>
									<el-col class="MT10"
										v-if="formData.douyinActivityBindRemark && showdouyinActivityStatus === 3">
										<span class="color-info">原因: </span>{{ formData.douyinActivityBindRemark }}
									</el-col>
								</el-row>
							</el-col>
						</el-row>
					</el-card>
				</el-row>
			</el-card>
			<el-card class="MT20" header="推送至支付宝公域">
				<div class="color-warning">该推送只影响演出是否能进入到支付宝公域，不影响演出本身在小程序内的展示和交易</div>
				<!-- <div class="MT10">当前推送状态：
					<span v-if="!formData.aliPoiId" class="color-danger MR10">缺失场地POI信息，无法推送，请 <span class="color-success hand" @click="download"> 下载模板</span> 后，找支付宝申请POI</span>
					<span v-if="formData.aliStatus">{{ AliSiteStatus.get(formData.aliStatus) }}</span>
					<span class="color-danger"
						v-if="formData.aliStatus == 3 || formData.aliStatus == 5 || formData.aliStatus == 8">（失败原因：{{ formData.aliFailReason }}）</span>
				</div> -->
				<div class="aliUL">
					<ul>
						<li>秀动演出ID：<span v-if="formData.activityId">{{ formData.activityId }}</span>，对应支付宝商品ID：<span
								v-if="formData.aliId">{{ formData.aliId }}</span></li>
						<li v-if="(formData.aliStatus == 4 || formData.aliStatus == 8 || formData.aliStatus == 9)">
							<el-button :loading="aliUpactivityLoading" @click="updateAli(2)" type="primary"
								size="small">点击更新演出信息</el-button> (演出标题、海报、活动类型、场地类型、票品价格改动后，需要更新)
						</li>
						<li v-if="formData.aliStatus == 7"><span class="color-disabled">暂时无法更新演出信息</span>
							(演出标题、海报、活动类型、场地类型、票品价格改动后，需要更新)</li>
						<li>最近上架时间:<span v-if="formData.aliPushTime">{{ formData.aliPushTime }}</span></li>
						<li>最近更新时间:<span v-if="formData.aliUpdateTime">{{ formData.aliUpdateTime }}</span></li>
						<li>最近下架时间:<span v-if="formData.aliDeleteTime">{{ formData.aliDeleteTime }}</span></li>
					</ul>
				</div>
				<div class="">
					<!--/activity/updateAliStatus  1：未上架 2：上架审核中 3：上架失败 4：已上架 5：下驾失败 6：已下架 7：修改审核中 8:修改审核失败 9:修改成功 -->
					<el-button v-if="(formData.aliStatus == 1 || formData.aliStatus == 3 || formData.aliStatus == 6)"
						type="primary" size="small" @click="updateAli(1)" :loading="aliUpLoading"
						title="缺失场地POI信息，无法推送">上架</el-button>
					<el-button
						v-if="(formData.aliStatus == 4 || formData.aliStatus == 5 || formData.aliStatus == 8 || formData.aliStatus == 9)"
						type="primary" size="small" @click="updateAli(3)" :loading="aliDownLoading">下架</el-button>

				</div>
			</el-card>
			<el-card class="MT20" header="推送至小红书:">
				<div class="color-warning">
					演出的推送, 默认会自动选择POI, 并创建服务组件, 服务组件需要审核<br>
					程序会定时获取审核状态, 只有审核通过了, POI 页面才可见服务组件<br>
					服务组件可以理解为小红书上演出展示卡片(类似于抖音POI页面下的团购商品), 目前可以在POI页面展示, 也可以被搜索<br>
					如果因为POI问题审核不通过, 可以手动重新选择POI并推送 (会重新审核)
				</div>
				<div class="MT40" style="font-size: 16px;">演出推送状态 ：
					<span v-if="formData.redStatus">{{ RebbookStatus.get(formData.redStatus) }}</span>

				</div>

				<div class="MT20" style="font-size: 16px;">
					<!-- 场地绑定 POI: 
					<span class="ML20">
						<span v-if="!formData.redBookletAuditStatus">未绑定</span>
						<span v-else>{{formData.redBookletAuditStatus}}</span>
					</span>					
					<span class="color-success ML20 hand" @click="$refs.PoiidBind.show()" v-if="!formData.redBookletAuditStatus || formData.redBookletAuditStatus == '审核拒绝'" >手动绑定POI</span>
					<span class="color-success ML20 hand" @click="unbindredbook()" v-if="formData.redBookletAuditStatus == '审核通过'">解除绑定</span>	 -->
					<div class="aliUL" style="font-size: 13px;">
						<ul>
							<!-- s -->
							<li>小红书POI名称 :
								<span v-if="formData.redPoiId">
									<el-popover title="POI图片" width="400" trigger="hover" placement="top">
										<el-image :src="formData.redPoiImage | coverImage(400, 400)" fit="cover"
											:preview-src-list="[formData.redPoiImage]"></el-image>
										</image-upload>
										<el-button type="text" slot="reference" size="mini"
											style="font-size: 14px;">{{ formData.redPoiName }}</el-button>
									</el-popover>
								</span>
								<span v-else>未绑定</span>
							</li>
							<!-- <li v-if="formData.linkUrl">绑定的小红书POI链接 : 
								<span class="color-success MR20">{{formData.linkUrl}}</span>
								<el-button type="primary" size="small" @click="copy" style="padding: 5px 10px;">复制POI链接</el-button>
								<input class="copyTool" ref="copyTool" :value="formData.linkUrl" />
							</li> -->
							<li>小红书POI ID : {{ formData.redPoiId }}</li>
							<li>服务组件ID : {{ formData.redComponentId }}</li>
						</ul>
					</div>
				</div>

				<div class="aliUL">
					<ul>
						<li>Product ID : <span v-if="formData.redId">{{ formData.redId }}</span></li>
						<li>状态更新时间 : <span v-if="formData.redUpdateTime">{{ formData.redUpdateTime }}</span></li>
						<li v-if="formData.redStatus == 3">失败原因：<span v-if="formData.redFailReason">{{
							formData.redFailReason
								}}</span></li>
					</ul>
				</div>
				<div class=""><!-- 小红书商品状态 1:未推送 2:推送成功 3:推送失败 4:下架' -->
					<el-button v-if="formData.redStatus == 1" @click="updateRedbook(1)" :loading="redbookLoading"
						type="primary" size="small">推送小红书</el-button>
					<el-button v-if="formData.redStatus == 3 || formData.redStatus == 4" @click="updateRedbook(1)"
						:loading="redbookLoading" type="primary" size="small">修改并推送</el-button>
					<el-button v-if="formData.redStatus == 2" @click="updateRedbook(2)" :loading="redbookLoading"
						type="primary" size="small">下架</el-button>
					<el-button v-if="formData.redStatus != 5" type="primary" size="small"
						@click="$refs.PoiidBind.show()">手选POI推送</el-button>
				</div>
			</el-card>
			<el-card class="MT20" header="推送至美团小程序:">
				<div style="font-size: 16px;">演出推送状态 ：
					<span v-if="formData.meiTuanStatus">{{ meiTuanStatus.get(formData.meiTuanStatus) }}</span>
				</div>
				<div class="meiTuanMain">
					<el-card shadow="always" style="width: 45%;">
						<div slot="header" class="clearfix">
							<el-button round type="primary" plain size="mini">Step1</el-button>
							<span class="ML10">绑定场地和美团POI</span>
						</div>
						<div class="MT20" style="font-size: 16px;">
							<div class="aliUL" style="font-size: 13px; min-height: 125px;">
								<ul>
									<li>绑定状态 : {{ meiTuanPoiStatus.get(formData.meiTuanPoiStatus) }}</li>
									<li>当前场地 : {{ formData.siteName }}</li>
									<li>美团POI ID : {{ formData.meiTuanPoiId }}</li>
									<li v-if="formData.meiTuanPoiTime">最近更新时间 : <span>{{ formData.meiTuanPoiTime
											}}</span></li>
									<li v-if="formData.meiTuanPoiStatus == 3">失败原因：<span
											v-if="formData.meiTuanPoiFailReason">{{
												formData.meiTuanPoiFailReason }}</span></li>
								</ul>
							</div>
						</div>
					</el-card>
					<i class="el-icon-right" style="font-size: 68px;"></i>
					<el-card shadow="always" style="width: 45%;">
						<div slot="header" class="clearfix">
							<el-button round type="primary" plain size="mini">Step2</el-button>
							<span class="ML10">推送演出项目至美团POI</span>
						</div>
						<div class="MT20" style="font-size: 16px;">
							<div class="aliUL" style="font-size: 13px; min-height: 125px;">
								<ul>

									<li>推送状态 : {{ meiTuanStatus.get(formData.meiTuanStatus) }}</li>
									<li>美团演出项目 ID: {{ formData.meiTuanId }}</li>
									<li v-if="formData.meiTuanPushTime">最近更新时间 : <span>{{ formData.meiTuanPushTime
											}}</span></li>
									<li>前置条件 : 需先完成Step1的美团POI绑定 </li>
									<li v-if="formData.meiTuanStatus == 3">失败原因：<span
											v-if="formData.meiTuanFailReason">{{
												formData.meiTuanFailReason }}</span></li>
									<li v-if="formData.meiTuanStatus == 4"> 下架时间：<span
											v-if="formData.meiTuanDeleteTime">{{
												formData.meiTuanDeleteTime }}</span></li>
									<li v-if="formData.meiTuanStatus == 2">
										商品更新提交后继续沿用当前在架商品售卖，更新审核结果仅影响新版本内容，不影响当前在架状态。</li>
								</ul>
							</div>
						</div>
					</el-card>
				</div>
				<div class="clearfix MT20"><!-- 0:未推送 1:推送中 2:推送成功3:推送失败4:下架" -->
					<el-button v-if="formData.meiTuanStatus == 0 || formData.meiTuanStatus == 3"
						@click="updatemeiTuan(1)" :loading="meiTuanLoading1" type="primary"
						size="small">推送美团</el-button>
					<el-button v-if="formData.meiTuanStatus == 2" @click="updatemeiTuan(2)" :loading="meiTuanLoading2"
						type="primary" size="small">修改并推送</el-button>
					<el-button v-if="formData.meiTuanStatus == 2" @click="updatemeiTuan(3)" :loading="meiTuanLoading3"
						type="primary" size="small">下架</el-button>
					<el-button v-if="formData.meiTuanStatus == 4" @click="updatemeiTuan(1)" :loading="meiTuanLoading1"
						type="primary" size="small">重新上架</el-button>
				</div>
			</el-card>


			<el-card class="MT20" header="限制开关">
				<el-form-item prop="sellAreaType" label="">
					<el-radio-group v-model="formData.sellAreaType">
						<el-radio :label="0">不限制</el-radio>
						<el-radio :label="1">限制，只能下面地区购买</el-radio>
						<el-radio :label="2">排除，下面地区不能购买</el-radio>
					</el-radio-group>
				</el-form-item>
				<template v-if="formData.sellAreaType != 0">
					<el-form-item prop="sellArea">
						<span slot="label">地区设置:<small>（同时选中父级和自己，只有父级生效，比如同时选择广东省，广东省/广州市，只有广东省生效）</small></span>
						<el-cascader v-model="formData.sellArea" :options="cityList" filterable
							:props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }"
							style="width:100%" ref="cityCascader">
						</el-cascader>
					</el-form-item>
				</template>
				<el-form-item prop="sellAreaModeshow" v-if="formData.sellAreaType != 0">
					<span slot="label"><span
							class="color-danger">*</span>地区限制方式:<small>（支持多选，但暂不支持对收货地址和下单时IP所在地区设置不同的限制逻辑）</small></span>
					<el-checkbox-group v-model="sellAreaModeshow">
						<el-checkbox :label="1">限制收货地址（限制购买需寄送的实体票时勾选该项）</el-checkbox>
						<el-checkbox :label="2">限制下单时IP所在地区（限制购买非寄送实体票时勾选该项）</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<template v-if="formData.sellAreaType != 0">
					<el-form-item prop="areaTip">
						<span slot="label">提示文案:<small>（提示用户为什么无法购买）</small></span>
						<el-input v-model="formData.areaTip" placeholder="请填写提示文案" :maxlength="150" type="textarea"
							:rows="3" show-word-limit></el-input>
					</el-form-item>
				</template>
			</el-card>
			<el-card class="MT20" header="定时购票设置" v-if="!formData.channelName">
				<el-form-item label="定时购票：" prop="preBuyStatus">
					<el-radio-group v-model="formData.preBuyStatus">
						<el-radio :label="1">开启（执行自动关闭）</el-radio>
						<el-radio :label="2">一直开启（不执行自动关闭）</el-radio>
						<el-radio :label="0">关闭（保留历史订单）</el-radio>
						<el-radio :label="-1">关闭（取消历史订单）</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="定时购模式：" prop="preBuyType">
					<el-radio-group v-model="formData.preBuyType" @change="changePreBuyType">
						<el-radio :label="1">定时抢票模式</el-radio>
						<el-radio :label="2">中签模式</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="preBuyDeadLine">
					<span slot="label">定时购票截止时间:<small><span
								class="color-danger">（填写距离结果公布时间前多少分钟停止下单）</span></small></span>
					<el-input-number style="width:50%" v-model="formData.preBuyDeadLine" :precision="0"
						controls-position="right" :min="10" :max="15000" size="medium"></el-input-number> 分钟
					<div v-if="preBuyDeadlineTime" class="MT10">
						<i class="el-icon-time"></i> 预计截止时间：{{ preBuyDeadlineTime }}
					</div>
				</el-form-item>
				<el-form-item prop="preBuyStock">
					<span slot="label">定时购票库存:<small><span
								class="color-danger">（每个票品将会从正常库存中取上面占比的库存数作为定时购票库存）</span></small></span>
					<el-input-number style="width:50%" v-model="formData.preBuyStock" :precision="0"
						controls-position="right" :min="0" :max="100" size="medium"></el-input-number> %

				</el-form-item>
				<el-form-item prop="preBuyPoint">
					<span slot="label">定时购票消耗秀豆:<small><span class="color-danger">（票价对应积分的百分比）</span></small></span>
					<el-input-number style="width:50%" v-model="formData.preBuyPoint" :precision="0"
						controls-position="right" :min="0" :max="10000" size="medium"></el-input-number> %
				</el-form-item>
				<el-form-item prop="preBuyCancelPoint">
					<span slot="label">取消定时购扣除秀豆设置:<small><span class="color-danger">（定时购使用秀豆的百分比）</span></small></span>
					<el-input-number style="width:50%" v-model="formData.preBuyCancelPoint" :precision="0"
						controls-position="right" :min="0" :max="100" size="medium"></el-input-number> %

				</el-form-item>
			</el-card>
		</el-form>
		<div class="MT20">
			<el-button @click="goBack">返回</el-button>
			<el-button v-if="$utils.have('/activity/saveActSellSetting')" type="primary" @click="onSubmit"
				:loading="btnLoading" :disabled="formData && formData.haveEditAudit">确认提交</el-button>
		</div>
		<PoiidBind ref="PoiidBind" :data="formData" @onUpdate="getDataDetail()"></PoiidBind>
	</div>
</template>

<script>
import { fetchAllCity, downloadFileTmp } from '@/assets/js/commonApi'
import Tab from '../components/tab';
import PoiidBind from './components/poiid-bind';

const defaultFormData = {
	sellIdentity: 1,
	sellTerminal: 1,

	appSellStatus: 1,
	appHideType: 0,

	wapSellStatus: 1,
	wapHideType: 0,

	byteSellStatus: 1,
	byteHideType: 0,

	redSellStatus: 1,
	redHideType: 0,

	meiTuanSellStatus: 1,
	meiTuanHideType: 1,

	taiYouthSellStatus: 1,
	taiYouthHideType: 2,


	wxSellStatus: 2,
	wxHideType: 0,

	aliSellStatus: 1,
	aliHideType: 0,

	webSellStatus: 2,
	webHideType: 0,

	sendOrderMsg: 1,
	invoiceStatus: 1,

	invoiceDays: 90,

	autoOpenAlternate: 1,
	autoOpenConsign: 1,
	autoOpenPreBuy: 1,
	seatEnter: 1,
	campusAgentStatus: 0,
	// isPushAppMsg:1,
	activityName: '',
	province: [],
	city: [],
	sellAreaType: 0,
	sellAreaMode: '',
	areaTip: '',
	sellArea: [],
	isBindHotel: 0,
	hotelId: "",
	// activeRefund: 0,
	openStrategy: 0,
	isShowCountdown: 0,
	douyinActivityName: '',
	douyinActivityType: '',

	preBuyStatus: 0,
	preBuyType: 1,


	preBuyStock: '',
	preBuyPoint: '',
	preBuyCancelPoint: '',
	preBuyDeadLine: 10
}
export default {
	props: {
		id: {
			type: [Number, String],
			default: () => null
		}
	},
	components: {
		Tab, PoiidBind
	},
	data() {
		return {
			dataDetail: null,
			formData: { ...defaultFormData },
			rules: {
				areaTip: [{ required: true, message: "请填写提示文案" }],
				sellArea: [{ required: true, message: "请选择地区" }],
				hotelId: [{ required: true, message: "请绑定酒店" }],
				accountLimitNum: [{ required: true, message: "请填写限购数量" }],
				preBuyDeadLine: [{ required: true, message: "请填写定时购票截止时间" }],
			},
			dataLoading: false,
			btnLoading: false,
			redirect: this.$route.query.redirect,
			cityList: [],

			hotelLoading: false,
			hotelList: [],
			sellAreaModeshow: [],
			douyinBindShow: false,
			showdouyinActivityStatus: '',
			status: '',
			// temp: {
			// 	params: [{ key: '' }]
			// },
			// ParamsNum: 0,
			// temp2: {
			// 	params: [{ key: '' }]
			// },
			// ParamsNum2: 0,
			// disStyle: 0,
			// disStyle2: 0,
			aliUpLoading: false,
			aliUpactivityLoading: false,
			aliDownLoading: false,
			expressDouyinDialog: false,
			expressOpenDouyin: [],
			expressBtnLoading: false,
			redbookLoading: false,
			showTypeTagList: [],
			copyTimer: null,

			douyinIdData: [],
			meiTuanLoading1: false,
			meiTuanLoading2: false,
			meiTuanLoading3: false
		}
	},
	async created() {
		await this.getCityList();
		this.getDataDetail();
		// this.addId()
		// this.addId2()
		// this.changeIpt()

	},
	computed: {
		douyinActivityStatus() {
			return new Map([
				[0, '未推送'],
				[1, '推送中'],
				[2, '推送成功'],
				[3, '推送失败'],
				[4, '已下架'],
			])
		},
		douyinSiteStatus() {
			return new Map([
				[0, '未绑定'],
				[1, '绑定中'],
				[2, '已绑定'],
				[3, '绑定失败']
			])
		},//1：未上架 2：上架审核中 3：上架失败 4：已上架 5：下驾失败 6：已下架 7：修改审核中 8:修改审核失败 9:修改成功
		AliSiteStatus() {
			return new Map([
				[1, '未上架'],
				[2, '上架审核中'],
				[3, '上架失败'],
				[4, '已上架'],
				[5, '下架失败'],
				[6, '已下架'],
				[7, '修改审核中'],
				[8, '修改审核失败'],
				[9, '修改成功'],
			])
		},
		RebbookStatus() {
			return new Map([
				[1, '未推送'],
				[2, '推送成功'],
				[3, '推送失败'],
				[4, '已下架'],
				[5, '审核中'],
			])
		},
		preBuyDeadlineTime() {
			if (!this.dataDetail || !this.dataDetail.firstStartSellTime || !this.formData.preBuyDeadLine) {
				return '';
			}
			var startTime = new Date(this.dataDetail.firstStartSellTime).getTime();
			if (isNaN(startTime)) {
				return '';
			}
			var deadline = startTime - this.formData.preBuyDeadLine * 60 * 1000;
			return this.$utils.formatDate(deadline, 'yyyy-MM-dd HH:mm:ss');
		},
		meiTuanStatus() {
			return new Map([
				[0, '未推送'],
				[1, '推送中'],
				[2, '推送成功'],
				[3, '推送失败'],
				[4, '已下架'],
			])
		},
		meiTuanPoiStatus() {
			return new Map([
				[0, '未绑定'],
				[1, '绑定中'],
				[2, '绑定成功'],
				[3, '绑定失败']
			])
		},
	},
	methods: {
		//返回
		goBack() {
			if (this.redirect) {
				this.$router.push({
					path: this.redirect,
				});
			} else {
				this.$router.go(-1);
			}
		},
		//获取详情
		getDataDetail() {

			this.dataLoading = true;
			this.$request({
				url: "/activity/actSellSetting",
				params: { activityId: parseInt(this.id) },
				method: "post",
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {
						this.getShowTypeTag();

						this.dataDetail = { ...result };
						this.formData = {
							...defaultFormData,
							...result,
							hotelId: result.hotelList ? result.hotelList.map(v => v.id) : "",
							hostApprovalQual: result.hostApprovalQual ? result.hostApprovalQual : [],
							ticketAgentQual: result.ticketAgentQual ? result.ticketAgentQual : [],
							preBuyDeadLine: result.preBuyDeadLine ? result.preBuyDeadLine : defaultFormData.preBuyDeadLine,

							// hostApprovalQual: ['75241724168100585333','7524172416810058531','7524172416810058532'],
							// ticketAgentQual: ['7524172235687346990','7524172235687346991','7524172235687346992']
						}
						this.hotelList = result.hotelList ? [...result.hotelList] : [];
						this.showdouyinActivityStatus = result.douyinActivityStatus
						if (result.sellAreaMode == 1) {
							this.sellAreaModeshow == [1]
							this.sellAreaModeshow = this.sellAreaModeshow.concat([1])
						} else if (result.sellAreaMode == 2) {
							this.sellAreaModeshow = this.sellAreaModeshow.concat([2])
						} else if (result.sellAreaMode == '') {
							this.sellAreaModeshow = this.sellAreaModeshow.concat([])
						} else {
							this.sellAreaModeshow = this.sellAreaModeshow.concat([1, 2])
						}

						this.douyinIdData = [this.formData.hostApprovalQual, this.formData.ticketAgentQual]
						// console.log(this.douyinIdData) 
					} else {
						this.$message.error(msg || "获取演出售票设置失败,请重试");
					}
				})
				.catch(() => {
					this.$message.error("获取演出售票设置失败,请重试");
				})
				.finally(() => {
					this.dataLoading = false;
				});
		},

		changeCountdown(val) {
			if (val !== 1) {
				return;
			}

			this.formData.isShowCountdown = 0;
			this.formData.province = [];
			this.formData.city = [];
			this.formData.sellArea.map(item => {
				if (!this.formData.province.find(v => v == item[0]) && !item[1]) {
					this.formData.province.push(item[0]);
				}
				item[1] && this.formData.city.push(item[1]);
			})
			var sellAreaMode = '';
			var sellAreaMode2 = '';
			sellAreaMode = this.sellAreaModeshow.toString();

			if (sellAreaMode == '' || this.formData.sellAreaType == 0) {
				sellAreaMode2 = 0
			} else if (sellAreaMode == 1) {
				sellAreaMode2 = 1
			} else if (sellAreaMode == 2) {
				sellAreaMode2 = 2
			} else {
				sellAreaMode2 = 3
			}

			if (this.formData.sellAreaType == 0) {
				this.formData.areaTip = ''
			}
			// 调用接口验证
			this.$request({
				url: "/activity/saveActSellSetting/check",
				method: "POST",
				data: {
					...this.formData,
					sellArea: null,
					hotelId: this.formData.hotelId.toString(),
					sellAreaMode: sellAreaMode2,
					isShowCountdown: 1
				},
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1 && result?.needTips && result?.tipsView) {
						// 需要弹窗提示
						this.$confirm(result.tipsView, '提示', {
							type: 'warning',
							center: false,
							confirmButtonText: '确认继续开启',
							cancelButtonText: '返回修改',
							closeOnClickModal: false,
						})
							.then(() => {
								this.formData.isShowCountdown = 1;

							})
							.catch(() => {

							});
					} else if (state == 1) {

						this.formData.isShowCountdown = 1;

					} else {

						this.$message.error(msg || '验证失败，请检查配置');
					}
				})
				.catch(() => {

					this.$message.error('请求失败，请稍后重试');
				});
		},
		//定时购票库存  preBuyStock 定时购票消耗秀豆preBuyPoint 取消定时购扣除秀豆设置  preBuyCancelPoint
		changePreBuyType(val) {
			if (val == 2) {
				this.formData.preBuyStock = 100
				this.formData.preBuyPoint = 0
				this.formData.preBuyCancelPoint = 0
			} else {
				this.formData.preBuyStock = 60
				this.formData.preBuyPoint = 90
				this.formData.preBuyCancelPoint = 20
			}
		},
		//获取活动类型
		getShowTypeTag() {
			this.$request({
				url: "/styleTag/showType/all",
				method: "post",
				params: { id: parseInt(this.id) }
			}).then(res => {
				const { state, result } = res.data;
				if (state == 1) {
					this.showTypeTagList = result || []
				}
			})
		},
		//获取城市列表
		async getCityList() {
			const res = await fetchAllCity({}).catch(() => { });
			const { state, result } = res.data;
			if (state == 1) {
				this.cityList = result;
			}
		},

		//复制链接
		copy() {
			clearTimeout(this.copyTimer);
			this.copyTimer = setTimeout(() => {
				const e = this.$refs.copyTool;
				e.select();
				document.execCommand("Copy"); // 执行浏览器复制命令
				this.$message.success("已复制成功，可粘贴");
			}, 300)
		},
		unbindredbook() {
			this.$confirm('确定要解除绑定吗?', '提示', {
				type: 'warning',
				center: true,
				closeOnClickModal: false
			}).then(() => {
				this.$request({
					url: "/site/unbindRedBookletPoi",
					method: "POST",
					params: { activityId: parseInt(this.id) },
				})
					.then((res) => {
						const { state, msg } = res.data;
						if (state == 1) {
							this.$message.success("操作成功");
							this.getDataDetail()
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
			}).catch(() => {

			})
		},
		changeDyType(type) {

			var _status = type
			var back = false, back1 = false;
			if (this.formData.status != 2) {
				return this.$message.error("只有预售中的演出才能推送到抖音生活");
			}

			if (this.douyinIdData[0].length == 0 && this.douyinIdData[1].length == 0) {
				return this.$message.error("主办批文资质id和演出主办方授权书 id不能为空");
			}
			if ((this.douyinIdData[0].length != this.douyinIdData[1].length) && type != 2) {
				return this.$message.error("主办批文资质id和演出主办方授权书必须对应且不能为空");
			}
			if (this.douyinIdData[0].length > 0) {
				this.douyinIdData[0].forEach((tab, idx) => {
					if (tab === '') {
						back = true
					}
				})
				if (back) {
					return this.$message.error("营业性演出准予许可决定资质ID不能为空");
				}
			}
			if (this.douyinIdData[1].length > 0) {
				this.douyinIdData[1].forEach((tab, idx) => {
					if (tab === '') {
						back1 = true
					}
				})
				if (back1) {
					return this.$message.error("演出主办方授权书资质ID不能为空");
				}
			}
			var hostApprovalQual = this.douyinIdData[0]
			var ticketAgentQual = this.douyinIdData[1]

			// console.log(hostApprovalQual);
			// console.log(ticketAgentQual);
			//return
			this.$request({
				url: "/activity/updateDouyinStatus",
				data: {
					activityId: parseInt(this.id),
					status: _status,
					hostApprovalQual: hostApprovalQual,
					ticketAgentQual: ticketAgentQual,
					activityName: this.formData.douyinActivityName,
					activityType: this.formData.douyinActivityType
				},
				method: "post",
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {

						this.$confirm('请检查抖音小程序的售票和展示开关是否设置正确', '操作成功', {
							type: 'success',
							center: false,
							showCancelButton: false,
							closeOnClickModal: false
						}).then(() => {
							this.expressDouyinDialog = false
							this.getDataDetail()
						}).catch(() => {
							this.expressDouyinDialog = false
						})

					} else {
						this.$message.error(msg || "操作失败,请重试");
					}
				})
				.catch(() => {
					this.$message.error("操作失败,请重试");
				})
		},

		addId() {
			this.douyinIdData[0].splice(this.douyinIdData[0].length, 0, '');
			console.log(this.douyinIdData[0])
		},
		del(index) {
			this.douyinIdData[0].splice(index, 1)
		},
		del2(index) {
			this.douyinIdData[1].splice(index, 1)
		},
		addId2() {
			this.douyinIdData[1].splice(this.douyinIdData[1].length, 0, '');
		},
		updateRedbook(type) {
			if (this.formData.status != 2 && type == 1) {
				return this.$message.error("只有预售中的演出才能推送到小红书");
			}
			var _status = type
			this.redbookLoading = true;
			this.$request({
				url: "/activity/updateRedStatus",
				params: {
					activityId: parseInt(this.id),
					status: _status
				},
				method: "post",
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {
						this.$message.success("操作成功");
						this.getDataDetail()
						this.redbookLoading = false;
					} else {
						this.$message.error(msg || "操作失败,请重试");
						this.redbookLoading = false;
					}
				})
				.catch(() => {
					this.$message.error("操作失败,请重试");
				})
		},
		updatemeiTuan(type) {
			if (this.formData.status != 2 && (type == 1 || type == 2)) {
				return this.$message.error("只有预售中的演出才能推送到美团");
			}
			var _status = type
			if (type == 1) {
				this.meiTuanLoading1 = true;
			}
			if (type == 2) {
				this.meiTuanLoading2 = true;
			}
			if (type == 3) {
				this.meiTuanLoading3 = true;
			}
			this.meiTuanLoading = true;
			this.$request({
				url: "/activity/updateMeiTuanStatus",
				params: {
					activityId: parseInt(this.id),
					status: _status
				},
				method: "post",
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {
						this.$message.success("操作成功");
						this.getDataDetail()
						if (type == 1) {
							this.meiTuanLoading1 = false;
						}
						if (type == 2) {
							this.meiTuanLoading2 = false;
						}
						if (type == 3) {
							this.meiTuanLoading3 = false;
						}
					} else {
						this.$message.error(msg || "操作失败,请重试");
						if (type == 1) {
							this.meiTuanLoading1 = false;
						}
						if (type == 2) {
							this.meiTuanLoading2 = false;
						}
						if (type == 3) {
							this.meiTuanLoading3 = false;
						}
					}
				})
				.catch(() => {
					this.$message.error("操作失败,请重试");
				})
		},
		//下载模板
		async download() {
			let filePath;
			let name;
			//this.downLoading = true;
			const res = await this.$request({
				url: '/activity/exportAliTemplate',
				method: 'post',
				params: {
					activityId: parseInt(this.id),
				}
			})
				.catch(err => {
					this.$message({ message: err.message, type: 'error' });
				})
			const { state, msg, result } = res.data;
			if (state == 1 && result) {
				filePath = result.url;
				name = result.fileName
			} else {
				//this.downLoading = false;
				return this.$message.error(msg || '下载失败');
			}

			await downloadFileTmp(filePath, name + '.' + this.$utils.getFileType(filePath));
			//this.downLoading = false;
		},
		updateAli(type) {
			var _status = type
			if (_status == 1) {
				this.aliUpLoading = true
			}
			if (_status == 2) {
				this.aliUpactivityLoading = true
			}
			if (_status == 3) {
				this.aliDownLoading = true
			}
			this.$request({
				url: "/activity/updateAliStatus",
				params: {
					activityId: parseInt(this.id),
					status: _status
				},
				method: "post",
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {
						this.$message.success("操作成功");
						this.getDataDetail()
						if (_status == 1) {
							this.aliUpLoading = false
						}
						if (_status == 2) {
							this.aliUpactivityLoading = false
						}
						if (_status == 3) {
							this.aliDownLoading = false
						}
					} else {
						this.$message.error(msg || "操作失败,请重试");
						if (_status == 1) {
							this.aliUpLoading = false
						}
						if (_status == 2) {
							this.aliUpactivityLoading = false
						}
						if (_status == 3) {
							this.aliDownLoading = false
						}
					}
				})
				.catch(() => {
					this.$message.error("操作失败,请重试");
				})
		},


		//酒店搜索
		async searchHotel(query) {
			if (query !== "") {
				this.hotelLoading = true;
				const res = await this.$request({
					url: '/hotel/getName',
					method: 'POST',
					params: { hotelId: query }
				}).finally(() => {
					this.hotelLoading = false;
				});

				const { state, result } = res.data;

				if (state == 1 && result) {
					if (!this.hotelList.find(v => v.id == result.id)) {
						this.hotelList.push(result)
					}
				}
			}
		},
		//表单提交
		onSubmit() {
			this.$refs["formData"].validate((valid) => {
				if (valid) {
					this.formData.province = [];
					this.formData.city = [];
					this.formData.sellArea.map(item => {
						if (!this.formData.province.find(v => v == item[0]) && !item[1]) {
							this.formData.province.push(item[0]);
						}
						item[1] && this.formData.city.push(item[1]);
					})
					var sellAreaMode = ''
					var sellAreaMode2 = ''
					sellAreaMode = this.sellAreaModeshow.toString();

					if (sellAreaMode == '' || this.formData.sellAreaType == 0) {
						sellAreaMode2 = 0
					} else if (sellAreaMode == 1) {
						sellAreaMode2 = 1
					} else if (sellAreaMode == 2) {
						sellAreaMode2 = 2
					} else {
						sellAreaMode2 = 3
					}

					if (this.formData.sellAreaType == 0) {
						this.formData.areaTip = ''
					}
					if ((this.formData.sellAreaType == 1 || this.formData.sellAreaType == 2) && sellAreaMode2 == 0) {
						this.$message.error("请选择地区限制方式");
						return
					} else {
						this.$request({
							url: "/activity/saveActSellSetting",
							method: "POST",
							data: {
								...this.formData,
								sellArea: null,
								hotelId: this.formData.hotelId.toString(),
								sellAreaMode: sellAreaMode2
							},
						})
							.then((res) => {
								//处理成功回调
								const { state, msg } = res.data;
								if (state && state == 1) {
									// this.$message.success("操作成功");
									this.$confirm('操作成功', '提示', {
										type: 'success',
										center: true,
										confirmButtonText: '返回上一页',
										cancelButtonText: '留在当前页面',
										closeOnClickModal: false
									}).then(() => {
										this.goBack();
									}).catch(() => {
										this.sellAreaModeshow = []
										this.getDataDetail();
									})
								} else {
									return this.$message.error(msg || "操作失败");
								}
							})

					}

				}
			});
		}
	}
}
</script>
<style lang="scss" scoped>
.meiTuanMain {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 20px;
}

.page-group-title span {
	font-size: 14px;
}

.ML50 {
	margin-left: 50px;

}

.MT40 {
	margin-top: 40px;
}

.copyTool {
	opacity: 0;
	filter: alpha(opacity=0);
	// height: 1px;
}

.lineH24 {
	line-height: 24px;
}

.disabled {
	color: #999
}

.hand {
	cursor: pointer;
	color: #1fbb7d
}

::v-deep .link-blue {
	color: #409EFF;
	text-decoration: none;
}

::v-deep .is-underline {
	color: #409EFF;
	text-decoration: none;
}

.aliUL {
	margin: 15px 0;

	li {
		margin-bottom: 10px;
	}
}

::v-deep .forms .el-radio__label,
::v-deep .formss .el-form-item__content {
	font-size: 12px;
}

::v-deep .forms .el-form-item {
	margin-bottom: 10px;
}

// 售票终端描述列表：堆叠时的块间距 + 收敛单元格内表单项边距
.terminal-desc {
	margin-bottom: 10px;

	::v-deep .el-form-item {
		margin-bottom: 0;
	}
}
</style>